import React, { createElement, memo, useCallback } from 'react';
import { buildKey } from '@yme/utils/common';
import { ButtonSquareStyled } from './styled';
function ButtonSquareComponent(props) {
    const { value, specialValue = undefined, setIsActive, index, isSelected, tagContent, tagContentProps, isDisabled, dataTestId = 'atom', } = props;
    const onClickHandler = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!isSelected) {
            setIsActive(index);
        }
    }, [index, isSelected, setIsActive]);
    if (!value && !specialValue) {
        return null;
    }
    const dataTestIdComponent = buildKey(dataTestId, 'button-square');
    return (React.createElement(ButtonSquareStyled, { isSelected: isSelected, onClick: onClickHandler, isDisabled: isDisabled, "data-testid": dataTestIdComponent }, createElement(tagContent, tagContentProps, specialValue || value)));
}
export const ButtonSquare = memo(ButtonSquareComponent);
ButtonSquare.displayName = 'ButtonSquare_Atom';
